/**
 * API di autenticazione e gestione utenti.
 */

import httpClient, { tokenStorage } from './httpClient';
import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL as string) || '/api';

export type UserRole = 'admin' | 'operator' | 'viewer';

export interface User {
  id: number;
  email: string;
  role: UserRole;
  is_active: boolean;
  created_at: string;
  last_login?: string | null;
}

export interface TokenPair {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: User;
}

export interface UserCreatePayload {
  email: string;
  password: string;
  role: UserRole;
}

export interface UserUpdatePayload {
  role?: UserRole;
  is_active?: boolean;
  password?: string;
}

export const authApi = {
  async login(email: string, password: string): Promise<TokenPair> {
    // Uso axios diretto: l'endpoint login non deve passare dall'interceptor
    const res = await axios.post<TokenPair>(`${API_BASE_URL}/auth/login`, {
      email,
      password,
    });
    return res.data;
  },

  async logout(): Promise<void> {
    const refresh = tokenStorage.getRefresh();
    if (!refresh) return;
    try {
      await httpClient.post('/auth/logout', { refresh_token: refresh });
    } catch {
      // Idempotente: token gia' scaduto/invalido → ok comunque
    }
  },

  async me(): Promise<User> {
    const res = await httpClient.get<User>('/auth/me');
    return res.data;
  },

  async listUsers(): Promise<User[]> {
    const res = await httpClient.get<User[]>('/auth/users');
    return res.data;
  },

  async createUser(payload: UserCreatePayload): Promise<User> {
    const res = await httpClient.post<User>('/auth/users', payload);
    return res.data;
  },

  async updateUser(id: number, payload: UserUpdatePayload): Promise<User> {
    const res = await httpClient.put<User>(`/auth/users/${id}`, payload);
    return res.data;
  },

  async deactivateUser(id: number): Promise<User> {
    const res = await httpClient.delete<User>(`/auth/users/${id}`);
    return res.data;
  },
};

export default authApi;
